



@if(!setting.configuration.uIoptions?.mergedMapAndListing) {

  @if (!disableHeader) {
    <ion-header [translucent]="true">
      <ion-toolbar class="lacademie-toolbar">
        <ion-buttons slot="start">
          <ion-menu-button (click)="closePopup()"></ion-menu-button>
        </ion-buttons>
        <ion-title style="font-size: 13px;">
          <div class="titleBar">
            {{ title  | translate }}
            @if (NotificationService.showNotificationBell) {
              <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
                <div class="bellimgContainer">
                  <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                  <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                  <!--<img id="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                  @if (this.valideNotification > 0) {
                    <div class="notificationCircle">
                      <p>{{this.valideNotification}}</p>
                    </div>
                  }
                </div>
              </ion-buttons>
            }
          </div>
        </ion-title>
      </ion-toolbar>
    </ion-header>
  }

  <ion-content [fullscreen]="false" class="content-theme-one">
    @if ((mobile  && !setting.navigationSetting) && setting.configuration.uIoptions) {
      <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
    }


    <div>
      <ion-segment class="buttons" [(ngModel)]="currentSegment" [ngClass]="{'ispopup': this.isPopup}">
        <ion-segment-button class="button" value="list">
          {{ 'Geolocation.List' | translate | uppercase }}
        </ion-segment-button>
        <ion-segment-button class="button" style="margin-right: 10px;" value="map">
          {{ 'Geolocation.Map' | translate | uppercase }}
        </ion-segment-button>
      </ion-segment>
    </div>

    <div [ngStyle]="{ height: (this.currentSegment == 'map' ? 'calc(100% - 48px)' : 'auto') }">
      @switch (currentSegment) {
        @case ('list') {
          <div class="locations-list">
            <div class="default-content">
              <ion-button expand="block" class="geobtn" (click)="useGeo()">
                {{ "Geolocation.UseGeolocation" | translate }}
                &nbsp;
                <ion-icon name="navigate"></ion-icon>
              </ion-button>
            </div>
            @for (location of locations; track location) {
              <location-banner [location]="location"></location-banner>
            }
            <div [ngClass]="{'navSpacing': this.setting.configuration?.uIoptions?.unDockNavigationBar && !this.setting.configuration?.uIoptions?.locationToPopup}"></div>
          </div>
        }
        @case ('map') {
          <div class="map-container">
            <locations-map [locations]="locations">
            </locations-map>
          </div>
        }
      }
    </div>
    <div [ngClass]="{ 'content-push-up': isPopup }">
    </div>

  </ion-content>
}

@if(setting.configuration.uIoptions?.mergedMapAndListing) {

  @if (!disableHeader) {
    <ion-header [translucent]="true">
      <ion-toolbar class="lacademie-toolbar" [ngClass]="{'toolbar-homers': homersLayout}">
        <ion-buttons slot="start">
          <ion-menu-button (click)="closePopup()"></ion-menu-button>
        </ion-buttons>
        <ion-title style="font-size: 13px;">
          <div class="titleBar" [ngClass]="{'simpsonFont': homersLayout, 'adjustedTitleFont': homersLayout}">
            @if(homersLayout) {
              {{ alttitle  | translate }}
            } @else {
              {{ title  | translate }}
            }
            <!--
            @if (NotificationService.showNotificationBell) {
              <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
                <div class="bellimgContainer">
                 
                  <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                  @if (this.valideNotification > 0) {
                    <div class="notificationCircle">
                      <p>{{this.valideNotification}}</p>
                    </div>
                  }
                </div>
              </ion-buttons>
            }
            -->
          </div>
        </ion-title>
      </ion-toolbar>
    </ion-header>
  }

  <ion-content [fullscreen]="false" class="content-theme-one" style="overscroll-behavior: contain;">
    @if ((mobile  && !setting.navigationSetting) && setting.configuration.uIoptions) {
      <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
    }



    <div >



      <div class="searchContainerSizer">
        <div class="searchContainer">
          <ion-icon name="search-outline" class="searchIcon"></ion-icon>

          <!--<input class="searchInput" [ngClass]="{'poppinsNormalFont': homersLayout, 'searchInput-homers': homersLayout}" type="text" placeholder="Search ..."/>-->
          <input
            class="searchInput"
            [ngClass]="{
              'poppinsNormalFont': homersLayout,
              'searchInput-homers': homersLayout
            }"
            type="text"
            placeholder="Search ..."
            [(ngModel)]="searchText"
            (input)="searchSubject.next(searchText)"
          />
        </div>
      </div>


      <!--temporarily used to make spacing-->
      <!--<div style="margin-bottom: 10px;"></div>-->


      @if(locations) {
        <div class="map-container map-framed" [ngClass]="{'map-framed-spacing': homersLayout}">
          <!--
          <locations-map [locations]="locations" [topframed]="true">
          </locations-map>
          -->

          <locations-map
            [locations]="displayedLocations"
            [mapCenter]="searchMapCenter"
            [topframed]="true">
          </locations-map>
        </div>
      }
      


      
      <div class="locations-list locations-list-framed">
        @if(!hasPosition && showGeoLocation) {
          <div class="default-content">
            <ion-button expand="block" class="geobtn" (click)="useGeo()">
              {{ "Geolocation.UseGeolocation" | translate }}
              &nbsp;
              <ion-icon name="navigate"></ion-icon>
            </ion-button>
          </div>
        }
        
        <!--
        @for (location of locations; track location) {
          <location-banner [location]="location"></location-banner>
        }
        -->
        @for (location of displayedLocations; track location) {
          <location-banner [location]="location"></location-banner>
        }
        <div [ngClass]="{'navSpacing': this.setting.configuration?.uIoptions?.unDockNavigationBar && !this.setting.configuration?.uIoptions?.locationToPopup}"></div>
      </div>
      


          


    </div>
    <div [ngClass]="{ 'content-push-up': isPopup }">
    </div>

  </ion-content>
}